import {logFirebaseEvent} from "../firebase";
import {isPublicAliasPath} from "./publicRouteAliases";

let lastPublicPath = null;

export function normalizeAnalyticsPath(pathname) {
  const raw = String(pathname || "/").split(/[?#]/, 1)[0] || "/";
  const normalized = `/${raw.replace(/^\/+|\/+$/g, "")}`;
  return normalized === "/" ? "/" : normalized;
}

export function isPublicAnalyticsPath(pathname) {
  const path = normalizeAnalyticsPath(pathname);
  return path !== "/login" && !path.startsWith("/aid") && !path.startsWith("/admin") && !isPublicAliasPath(path);
}

export function trackSpaPageView({pathname, origin = "", title = ""} = {}) {
  const pagePath = normalizeAnalyticsPath(pathname);
  if (!isPublicAnalyticsPath(pagePath) || lastPublicPath === pagePath) return false;
  lastPublicPath = pagePath;
  return logFirebaseEvent("page_view", {
    page_path: pagePath,
    page_location: `${String(origin || "").replace(/\/$/, "")}${pagePath}`,
    page_title: String(title || "VonTheKeyz").slice(0, 150),
  });
}

export function resetSpaAnalyticsForTest() {
  lastPublicPath = null;
}
